import React from 'react';

export interface IOptions {
  type?: string
  label: string
  name?: string
}

interface IMenuSelectProps {
  ciq?: any,
  deleteItem?: (options: IOptions) => void,
  editItem?: (options: IOptions) => void,
  handleOptionSelect: (ciqOroptions: any | IOptions, options?: IOptions) => void,
  hasButtons?: boolean,
  hasCheckboxes?: boolean,
  keyName?: string,
  labelNeedsTransform?: boolean,
  labelTransform?: (options: IOptions) => void,
  menuId: string,
  name?: string,
  needsCiq?: boolean,
  noButtons?: any[],
  options: IOptions[],
  selected?: IOptions | IOptions[],
  title: string,
}

interface IMenuSelectState {
  hasButtons?: boolean,
  hasCheckboxes: boolean,
  menuOpen: boolean,
  selected?: IOptions | IOptions[]
}

export class MenuSelect extends React.Component<IMenuSelectProps, IMenuSelectState> {
  public static getDerivedStateFromProps(nextProps: IMenuSelectProps, nextState: IMenuSelectState) {
    if (nextProps.selected !== nextState.selected) {
      return {
        selected: nextProps.selected
      };
    }
    return null;
  }
  constructor(props: IMenuSelectProps) {
    super(props);
    if (!props.options) {
      throw new Error('Options do not exist')
    }
    this.state = {
      hasButtons: props.hasButtons,
      hasCheckboxes: !!props.hasCheckboxes,
      menuOpen: false,
      selected: props.selected
    };

    this.toggleMenu = this.toggleMenu.bind(this);
    this.edit = this.edit.bind(this);
    this.delete = this.delete.bind(this);
    this.selectOption = this.selectOption.bind(this);
  }

  public toggleMenu(open: boolean) {
    this.setState({ menuOpen: open });
  }

  public edit(option: IOptions, event: React.MouseEvent<HTMLDivElement>) {
    event.stopPropagation();
    if (this.props.editItem) {
      this.props.editItem(option);
    }
  }

  public delete(option: IOptions, event: React.MouseEvent<HTMLDivElement>) {
    event.stopPropagation();
    if (this.props.deleteItem) {
      this.props.deleteItem(option);
    }
  }

  public selectOption(ciq: any, option: IOptions) {
    const oldOption = this.state.selected;
    this.setState(
      {
        menuOpen: false,
        selected: option
      },
      () => {
        // Call handleOptionSelect when the option selected has actually changed, ignore this when selecting '+ New Theme' from the theme menu
        if (
          oldOption !== option ||
          (oldOption.type &&
            option.type &&
            oldOption.type !== option.type &&
            oldOption.label &&
            option.label &&
            oldOption.label !== option.label) ||
          (option.name && option.name.indexOf('New Theme') > -1)
        ) {
          if (Object.keys(ciq).length > 0) {
            this.props.handleOptionSelect(ciq, option);
          } else {
            this.props.handleOptionSelect(option);
          }
        }
      }
    );
  }

  public render() {
    if (this.props.options.length === 0) {
      return <div />;
    }

    const options = this.props.options.map((option, i) => {
      const onSelect = this.props.needsCiq
        ? this.selectOption.bind(this, this.props.ciq, option)
        : this.selectOption.bind(this, {}, option);
      const optionLabel = this.props.name
        ? option[this.props.name]
        : this.props.labelNeedsTransform
        ? this.props.labelTransform && this.props.labelTransform(option)
        : option;
      let buttonCName;
      if (this.state.selected && Array.isArray(this.state.selected)) {
        buttonCName = this.state.selected.includes(optionLabel) ? 'ciq-checkbox ciq-active' : 'ciq-checkbox';
      } else {
        buttonCName = this.state.selected && option === this.state.selected ? 'ciq-checkbox ciq-active' : 'ciq-checkbox';
      }

      return (
        <menu-option key={'menuSelectOption' + this.props.keyName + i} onClick={onSelect}>
          {this.state.hasButtons && this.props.noButtons && this.props.noButtons.indexOf(optionLabel) === -1 ? (
            <span>
              <span className='ciq-edit' onClick={this.edit.bind(this, option)} />
              <cq-close onClick={this.delete.bind(this, option)} />
            </span>
          ) : null}

          {this.state.hasCheckboxes ? (
            <div>
              <span className={buttonCName}>
                <span />
              </span>
            </div>
          ) : null}

          {optionLabel}
        </menu-option>
      );
    });

    const menuDisplay = {
      display: this.state.menuOpen ? 'block' : 'none'
    };

    return (
      <menu-select
        id={this.props.menuId}
        onMouseLeave={this.toggleMenu.bind(this, false)}
        onClick={this.toggleMenu.bind(this, !this.state.menuOpen)}
      >
        <span className='title'>{this.props.title}</span>
        <menu-select-options className='ps-container' style={menuDisplay}>
          {options}
        </menu-select-options>
      </menu-select>
    );
  }
}